<svg class="d-block w-50 mx-auto">
  <use href="/assets/images/logo/logo.nspace.svg#logo"></use>
</svg>
